module.exports = __webpack_public_path__ + "img/kuang_96296bc71.png";